import React from "react";
import Icon from "../icons/Icon";

function SearchInput({ value, onChange, label, placeholder }) {
  return (
    <div className="search">
      <Icon name="search" />
      <input
        className="input"
        type="search"
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}

export default SearchInput;
